export default __webpack_public_path__ + "static/media/logo_iraha.77502233.png";